import React from 'react';
import '../styles/ExternalLinkIcon.css';

const ExternalLinkIcon = ({ className = '' }) => (
  <span className={`external-link-icon ${className}`} aria-hidden="true">
    <span className="icon-desktop">↗</span>
    <svg className="icon-mobile" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path fill="currentColor" d="M14 3h7v7h-2V6.41L7.41 18 6 16.59 17.59 5H14V3z" />
    </svg>
  </span>
);

export default ExternalLinkIcon;
